<template>
  <b-modal
    ref="exclude-bill-reward-list-modal"
    title="Danh sách hoá đơn không được tính thưởng"
    size="md"
  >
    <b-table
      :items="listItems"
      :fields="fields"
      bordered
      hover
      show-empty
      :empty-text="'Chưa có hoá đơn nào'"
    >
      <template #cell(count)="row">
        {{ row.index + 1 }}
      </template>
      <template #cell(billNumber)="row">
        {{ row.item.billNumber }}
      </template>
    </b-table>
    <template #modal-footer>
      <b-button variant="secondary" @click="hideModal">Đóng</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalExcludeBillRewardList',
  props: {
    listBillNumber: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'billNumber',
          label: 'Mã hoá đơn',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
      ],
    };
  },
  computed: {
    listItems() {
      return (this.listBillNumber || []).map((billNumber) => ({
        billNumber,
      }));
    },
  },
  methods: {
    showModal() {
      this.$refs['exclude-bill-reward-list-modal'].show();
    },
    hideModal() {
      this.$refs['exclude-bill-reward-list-modal'].hide();
    },
  },
};
</script>
